import { types } from '../../types/types';
import {
  MENU_MESA_ENTRADA,
  MESA_ENTRADA_COMPROBANTES_ESTADOS,
  STEPPER_EXPEDIENTE_FORM,
  TIPO_COMPROBANTE_DOCUMENTO,
  TIPO_EFECTORES,
} from '../../utils/constants';
import { mesaEntradaTypes } from './mesaEntradaTypes';

const initialState = {
  activeBreadcrumb: MENU_MESA_ENTRADA.DESELECCIONAR,
  activeStep: STEPPER_EXPEDIENTE_FORM.TRAMITE_COMPROBANTE,
  comprobantes: [],
  comprobanteTomado: null,
  proformaTomada: null,
  proformas: [],
  menuProforma: false,
  destinos: [],
  documentacion: [],
  estadoComprobante: MESA_ENTRADA_COMPROBANTES_ESTADOS.ENVIADA?.toString(),
  presupuestos: [],
  presupuesto: null,
  cotizaciones: [],
  procedencia: [],
  recepcionMenu: 0,
  tipoEfectorMenu: TIPO_EFECTORES.CONTRATO_PRESTADORES,
  tipoComprobanteDocumentoMenu: TIPO_COMPROBANTE_DOCUMENTO.DOCUMENTACION,
  tipoComprobante: [],
  tipoFactura: [],
  tramites: [],
  trackingExpedientes: [],
  lineasSolicitudes: [],
  usuarioLiquidaciones: '',
  trackingTramitesDestinos: [],
  remitos:[],
  loading: false,
};

export const mesaEntradaReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.comprobanteMesaEntradaStart:
      return {
        ...state,
        loading: true,
      };
    case types.comprobanteMesaEntradaClean:
      return {
        ...state,
        comprobantes: [],
        loading: true,
      };
    case types.comprobanteMesaEntradaSuccess:
      return {
        ...state,
        comprobantes: action.payload,
        loading: false,
      };
    case types.comprobanteMesaEntradaError:
      return {
        ...state,
        loading: false,
      };
    case types.comprobanteMesaEntradaGuardar:
      return {
        ...state,
        comprobantes: [action.payload, ...state.comprobantes.slice(0, 9)],
        loading: false,
      };
    case types.comprobanteMesaEntradaModificar:
      return {
        ...state,
        comprobantes: state.comprobantes.map((item) =>
          action.payload.idExpedientes.find((id) => item.idExpediente === id)
            ? { ...item, idDestino: action.payload.idDestino }
            : item,
        ),
        loading: false,
      };
    case types.comprobanteMesaEntradaEliminar:
      return {
        ...state,
        comprobantes: state.comprobantes.filter(
          (item) => item.idExpediente !== action.payload,
        ),
        loading: false,
      };
    case types.comprobanteMesaDirectoEliminar:
      return {
        ...state,
        comprobantes: state.comprobantes.filter(
          (item) => item.id !== action.payload,
        ),
        loading: false,
      };
    case types.datosComprobanteStart:
      return {
        ...state,
        loading: true,
      };
    case types.tipoComprobanteSuccess:
      return {
        ...state,
        tipoComprobante: action.payload,
        loading: false,
      };
    case types.tipoComprobanteError:
      return {
        ...state,
        loading: false,
      };
    case types.tipoFacturaSuccess:
      return {
        ...state,
        tipoFactura: action.payload,
        loading: false,
      };
    case types.tipoFacturaError:
      return {
        ...state,
        loading: false,
      };
    case types.procedenciaSuccess:
      return {
        ...state,
        procedencia: action.payload,
        loading: false,
      };
    case types.procedenciaError:
      return {
        ...state,
        loading: false,
      };
    case types.comprobanteMesaEntradaActualizacionEstado:
      return {
        ...state,
        estadoComprobante: action.payload,
        loading: false,
      };
    case types.datosExpedienteStart:
      return {
        ...state,
        loading: true,
      };
    case types.tramitesSuccess:
      return {
        ...state,
        tramites: action.payload,
        loading: false,
      };
    case types.tramitesError:
      return {
        ...state,
        loading: false,
      };
    case types.destinosSuccess:
      return {
        ...state,
        destinos: action.payload,
        loading: false,
      };
    case types.destinosError:
      return {
        ...state,
        loading: false,
      };
    case types.mesaEntradaGetPresupuestosSuccess:
      return {
        ...state,
        presupuestos: action.payload,
      };
    case types.mesaEntradaDeletePresupuesto:
        return {
          ...state,
          presupuestos: state.presupuestos.filter(item => item.idPrespuesto !== action.payload),
        };
    case types.mesaEntradaCleanPresupuestos:
      return {
        ...state,
        presupuestos: [],
      };
    case types.mesaEntradaTomarPresupuesto:
      return {
        ...state,
        presupuesto: action.payload,
      };
    case types.mesaEntradaLiberarPresupuesto:
      return {
        ...state,
        presupuesto: null,
      };
    case types.mesaEntradaGetCotizacionesSuccess:
      return {
        ...state,
        cotizaciones: action.payload,
      };
    case types.mesaEntradaGetCotizacionesError:
      return {
        ...state,
        cotizaciones: [],
      };
    case types.recepcionComprobanteSetMenu:
      return {
        ...state,
        recepcionMenu: action.payload,
      };
    case types.tipoEfectorMenuSet:
      return {
        ...state,
        tipoEfectorMenu: action.payload,
      };
    case types.setActiveBreadcrumbMesa:
      return {
        ...state,
        activeBreadcrumb: action.payload,
      };
    case types.mesaEntradaSetStep:
      return {
        ...state,
        activeStep: action.payload,
      };
    case types.trackingExpedientesSuccess:
      return {
        ...state,
        trackingExpedientes: action.payload,
        loading: false,
      };
    case types.trackingExpedientesError:
      return {
        ...state,
        trackingExpedientes: [],
        loading: false,
      };
    case types.documentacionMesaEntradaClean:
      return {
        ...state,
        documentacion: [],
      };
    case types.documentacionMesaEntradaSucces:
      return {
        ...state,
        documentacion: action.payload,
      };
    case types.documentacionMesaEntradaInsert:
      return {
        ...state,
        documentacion: [...state.documentacion, ...action.payload],
      };
    case types.documentacionMesaEntradaEliminar:
      return {
        ...state,
        documentacion: state.documentacion.filter(
          (item) => item.idDocumentacionComprobante !== action.payload,
        ),
      };
    case types.documentacionMesaEntradaError:
      return {
        ...state,
        documentacion: [],
      };
    case types.comprobanteTomar:
      return {
        ...state,
        comprobanteTomado: action.payload,
      };
    case types.comprobanteLiberar:
      return {
        ...state,
        comprobanteTomado: null,
      };
    case types.proformaMesaEntradaStart:
      return {
        ...state,
        loading: true,
      };
    case types.proformaMesaEntradaClean:
      return {
        ...state,
        proformas: [],
        loading: true,
      };
    case types.proformaMesaEntradaSuccess:
      return {
        ...state,
        proformas: action.payload,
        loading: false,
      };
    case types.proformaMesaEntradaError:
      return {
        ...state,
        loading: false,
      };
    case types.proformaMesaEntradaDelete:
      return {
        ...state,
        proformas: state.proformas.filter(
          (item) => item.idExpediente !== action.payload,
        ),
        loading: false,
      };
    case types.tomarProforma:
      return {
        ...state,
        proformaTomada: action.payload,
      };
    case types.liberarProforma:
      return {
        ...state,
        proformaTomada: null,
      };
    case types.setMenuProforma:
      return {
        ...state,
        menuProforma: action.payload,
      };
    case types.setMenuComprobanteDocumentacion:
      return {
        ...state,
        tipoComprobanteDocumentoMenu: action.payload,
      };
    case types.solicMesaEntradaStart:
      return {
        ...state,
        loading: true,
      };
    case types.solicMesaEntradaClean:
      return {
        ...state,
        lineasSolicitudes: [],
        loading: true,
      };
    case types.solicMesaEntradaSuccess:
      return {
        ...state,
        lineasSolicitudes: action.payload,
        loading: false,
      };
    case types.solicMesaEntradaError:
      return {
        ...state,
        loading: false,
      };
    case types.usuarioLiquidacionesSuccess:
      return {
        ...state,
        usuarioLiquidaciones: action.payload,
        loading: false,
      };
    case types.usuarioLiquidacionesError:
      return {
        ...state,
        loading: false,
      };
    case types.setUsuarioLiquidaciones:
      return {
        ...state,
        usuarioLiquidaciones: action.payload,
        loading: false,
      };

    case mesaEntradaTypes.getTramites:
      return {
        ...state,
        tramites: action.payload,
      };
    case mesaEntradaTypes.cleanTramites:
      return {
        ...state,
        tramites: [],
      };
    case mesaEntradaTypes.updateTramite:
      return {
        ...state,
        tramites: state.tramites.map((item) =>
          item.idTramite === action.payload.id
            ? {
                ...item,
                idDestino: action.payload.idDestino,
              }
            : item,
        ),
      };

    case mesaEntradaTypes.getDestinos:
      return {
        ...state,
        destinos: action.payload,
      };
    case mesaEntradaTypes.cleanDestinos:
      return {
        ...state,
        destinos: [],
      };
    case mesaEntradaTypes.getTrackingTramitesDestinos:
      return {
        ...state,
        trackingTramitesDestinos: action.payload,
      };
    case mesaEntradaTypes.cleanTrackingTramitesDestinos:
      return {
        ...state,
        trackingTramitesDestinos: [],
      };
    case types.getremitosSuccess:
      return {
        ...state,
        remitos: action.payload,
        loading: false,
        };
    default:
      return state;
  }
};
